var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dowPdf",on:{"click":_vm.rightShare}},[_vm._v("下载详情")])}
var staticRenderFns = []

export { render, staticRenderFns }